import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from '@lib/components';
import { StaticMsgModule } from '@lib/pipes';
import { InformationsDuringStayComponent } from './informations-during-stay.component';

@NgModule({
  declarations: [InformationsDuringStayComponent],
  imports: [CommonModule, ButtonModule, StaticMsgModule],
  exports: [InformationsDuringStayComponent],
})
export class InformationsDuringStayModule {}
